module.exports = __webpack_public_path__ + "static/media/family_02.d3f86452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_02.jpg
// module id = 5834
// module chunks = 0